export const focusNext = (value: string, el: HTMLInputElement) => {
  const form = el.form;
  if (!form) return;
  const index = Array.from(form.elements).findIndex(item => item === el);
  if (index === -1) return;
  const next = form.elements.item(index + 1);
  if (next) (next as HTMLInputElement).focus();
};
